function Status({ status }: {status: string }) {
  return (
    <div className="ui-status">
      <span className={`status ${status.toLowerCase()}`}>{status}</span>
    </div>
  );
}

export default Status;
